import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';
import { LoadingModule } from '../loading/loading.module';

import { FileUploader } from './file-uploader.component';
import { File } from './file.component';

export { FileUploader } from './file-uploader.component';

@NgModule({
  declarations: [
    FileUploader,
    File
  ],
  exports: [
    FileUploader
  ],
  imports: [
    CommonModule,
    ButtonModule,
    IconModule,
    LoadingModule,
  ]
})
export class FileUploaderModule { }
